/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFileWebAppLinkQueryResponse, IngestionStatusControllerGetFileWebAppLinkPathParams, IngestionStatusControllerGetFileWebAppLink403, IngestionStatusControllerGetFileWebAppLink404 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFileWebAppLink";

function getIngestionStatusControllerGetFileWebAppLinkUrl(fileId: IngestionStatusControllerGetFileWebAppLinkPathParams["fileId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/files/${fileId}/web-app-link` as const }  
  return res
}

/**
 * @description Returns the canonical fully-qualified URL for opening this file in the main web app. The host is sourced from FRONTEND_URL (set per environment by Pulumi). Requires System Administrator role.
 * @summary Resolve the main web app URL for a file
 * {@link /api/v1/documents/ingestion-status/files/:fileId/web-app-link}
 */
export async function ingestionStatusControllerGetFileWebAppLink(fileId: IngestionStatusControllerGetFileWebAppLinkPathParams["fileId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetFileWebAppLinkQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileWebAppLink403 | IngestionStatusControllerGetFileWebAppLink404>, unknown>({ method : "GET", url : getIngestionStatusControllerGetFileWebAppLinkUrl(fileId).url.toString(), ... requestConfig })  
  return res.data
}